import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import "./../../bindings/bao-number-box";
function DefaultTag(tagViewModel, tagId) {
    var self = this;
    self.Parent = tagViewModel;
    self.LimitLower = ko.observable();
    self.LimitUpper = ko.observable();
    self.Decimals = ko.observable(0);
    self.TagId = tagId;
    self.IsReadOnly = ko.observable(false);
    self.ValueValidCss = null;
    self.init = function () {
        var value = tagViewModel.getTagObservable(self.TagId);
        var tagModel = tagViewModel.getTagModel(self.TagId);
        if (ko.unwrap(tagModel.Decimals) != null) {
            self.Decimals(ko.unwrap(tagModel.Decimals));
        }
        if (ko.unwrap(tagModel.ReadOnly) != null) {
            self.IsReadOnly(ko.unwrap(tagModel.ReadOnly));
        }
        if (value) {
            self.LimitLower(ko.unwrap(value.LimitLower));
            self.LimitUpper(ko.unwrap(value.LimitUpper));
            self.ValueValidCss = ko.computed(function () {
                var val = ko.unwrap(value.NumericValue);
                var cssClasses = "";
                if (self.LimitLower() == null && self.LimitUpper() == null) {
                    cssClasses = "form-control pull-left";
                }
                else if (val == null || val === "") {
                    cssClasses = "form-control pull-left";
                }
                if (self.LimitLower() != null && val < self.LimitLower() || self.LimitUpper() != null && val > self.LimitUpper()) {
                    cssClasses = "form-control alert-danger pull-left";
                }
                else {
                    if (self.LimitLower() != null || self.LimitUpper() != null) {
                        cssClasses = "form-control alert-success pull-left";
                    }
                    else {
                        cssClasses = "form-control pull-left";
                    }
                }
                if (ko.unwrap(tagModel.IsMandatory)) {
                    cssClasses += " isMandatory";
                }
                return cssClasses;
            });
        }
    };
}
DefaultTag.prototype.dispose = function () { };
export default DefaultTag;